import { Box, Container, Flex, Image, Text, Link } from '@chakra-ui/react';

import { SuccessScreenViewProps } from './SuccessScreen.props';
import styles from './styles.module.css';
import headerLogoSucess from 'assets/images/pelikin_logo_scaled.png';
import appleStoreLogo from 'assets/images/apple_store_logo.png';
//import mobileImage from 'assets/images/phone_image.png';
import qrCode from 'assets/images/qr_code.png';
import googlePlayLogo from 'assets/images/google_play_logo.png';
//import appleStore from 'assets/images/apple_store.png';
import useWindowDimensions from 'hooks/useWindowDimensions';
import closeIcon from 'assets/images/close_icon.png';
//import { ClassNames } from '@emotion/react';


const SuccessScreenView = ({
  history,
}: SuccessScreenViewProps): JSX.Element => {
  const { height, width } = useWindowDimensions();
  //const imageMobileWidth = height > 810 ? 300 : 240;
  const isMobileDevice = width < 421;
  //const isMobileDevice = width < 600;

  function showMobilePayIcons() {
    return (
      <div className={styles.mobilePayIconsContainer}>
        <a
          href="https://apps.apple.com/au/app/pelikin/id1444828880"
          target={'_blank'}
          rel="noreferrer"
        >
          <Image className={styles.storeIconsMobile} src={appleStoreLogo}></Image>
        </a>

        <a
          href="https://play.google.com/store/apps/details?id=co.pelikin.pelikin"
          target={'_blank'}
          rel="noreferrer"
        >
          <Image className={styles.storeIconsMobile} src={googlePlayLogo}></Image>
        </a>

      </div>
    );
  }

  function showDesktopPayIcons() {
    return (
      <div className={styles.payIconsContainerDesktop}>
        <a
          href="https://apps.apple.com/au/app/pelikin/id1444828880"
          target={'_blank'}
          rel="noreferrer"
        >
          <Image className={styles.storeIconsDesktop} src={appleStoreLogo}></Image>
        </a>

        <a
          href="https://play.google.com/store/apps/details?id=co.pelikin.pelikin"
          target={'_blank'}
          rel="noreferrer"
        >
          <Image className={styles.storeIconsDesktop} src={googlePlayLogo}></Image>
        </a>
      </div>
    );
  }

function showCheckInboxText(){
  return (
    <div>
    <Text className={styles.description2}>
      Check your inbox! We've sent you an email to help you finish setting up your account and travel card.
    </Text>
  </div>
  );
}

  function showQrCode() {
    return (
      <>
        <Image className={styles.qrCode} src={qrCode}></Image>
      </>
    );
  }

  return (
    <Flex className={ isMobileDevice ?  styles.containerMobile : styles.container}>
      <Container
        className={styles.box}
        position={['absolute', 'relative']}>
        <div className={styles.headerContainer}>
          <Image
            src={closeIcon}
            className={styles.closeButton}
            maxHeight={90}
            width={4}
            height={4}
            position={'absolute'}
            right={5}
            top={5}
            onClick={() => history.goBack()}
          />

          <Text className={styles.welcomeText}>
            Welcome to
          </Text>

          <Image
            src={headerLogoSucess}
            className={styles.pelikinLogo}
            maxWidth={180}
          />
          <div className={ styles.descriptionContainer}>
            <Text className={styles.description}>
              Download the app, get your card and start spending in minutes.
            </Text>
          </div>

          {!isMobileDevice  && showQrCode()}
          {!isMobileDevice && showCheckInboxText()}

          {isMobileDevice && showMobilePayIcons()}
          {!isMobileDevice && showDesktopPayIcons()}
          {isMobileDevice && showCheckInboxText()}
        </div>

      </Container>
    </Flex>
  );
};

export default SuccessScreenView;
